import Fiver_one from "../../assets/Fiver_one.png";
import Fiverr_two from "../../assets/Fiverr_two.png";
import Fiver_three from "../../assets/Fiver_three.png";
import Fiver_four from "../../assets/Fiver_four.png";
import Fiver_five from "../../assets/Fiver_five.png";
import Fiver_six from "../../assets/Fiver_six.png";
import Fiver_seven from "../../assets/Fiver_seven.png";
import Fiver_eight from "../../assets/Fiver_eight.png";
import Fiver_nine from "../../assets/Fiver_nine.png";
import Fiver_ten from "../../assets/Fiver_ten.png";
import Upwork_one from "../../assets/Upwork_one.png";

// ========== TESTIMONIALS DATA ==========
export const Data = [
  {
    id: 1,
    image: Fiver_one,
    title: "nedb2k | Ireland",
    description:
      "He provided me with exactly what I was looing for! Great communicator and always provided me with insight of the project! He put in a real shift to get the project exactly how I wanted it! I Really Recommend this guy!",
  },
  {
    id: 2,
    image: Fiverr_two,
    title: "asiftalukder",
    description:
      "I highly recommend that you can rely on him for your project. He maintain very good communication with his clients and follow the requirements very carefully. Also serve fast delivery.",
  },
  {
    id: 3,
    image: Fiver_seven,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 4,
    image: Fiver_four,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 5,
    image: Fiver_five,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 6,
    image: Fiver_six,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 7,
    image: Fiver_three,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 8,
    image: Fiver_eight,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 9,
    image: Fiver_nine,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 10,
    image: Fiver_ten,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 11,
    image: Upwork_one,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
];
